import 'whatwg-fetch'
import {API_URL} from '../constants/configValues'

const chart = {
  fetchChartDeviceData(token, systemID, stationID, deviceID, from, to, offset, limit) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/statistics/${stationID}/deviceAin/${deviceID}/${from}/${to}/${offset}/${limit}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchTimeLineDeviceData(token, systemID, stationID, deviceID, from, to, offset, limit) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/statistics/${stationID}/deviceDin/${deviceID}/${from}/${to}/${offset}/${limit}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchChartDevicesData(token, systemID, stationID, deviceIDs, from, to) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/statistics/${stationID}/device-data/${deviceIDs}/${from}/${to}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchChartPowerMeterDayData(token, systemID, stationID, deviceID, from, to, offset, limit) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/statistics/${stationID}/power-meter/day/${deviceID}/${from}/${to}/${offset}/${limit}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchChartPowerMeterMonthData(token, systemID, stationID, deviceID, from, to, offset, limit) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/statistics/${stationID}/power-meter/month/${deviceID}/${from}/${to}/${offset}/${limit}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default chart



// WEBPACK FOOTER //
// ./src/api/chart.js